"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterWrapper = exports.Paper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const pageIn = (0, styled_components_1.keyframes) `
  from {
    opacity: 0;
    transform: translateY(30%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;
exports.Paper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 0.5 1 600px;
  justify-content: space-around;
  align-items: center;
  position: relative;
  overflow: hidden;
  height: 80%;
  min-height: 300px;
  max-height: 500px;
  max-width: 800px;

  padding: 20px;
  margin: auto 20px;
  border-radius: 3px;
  box-shadow: 0 4px 8px #00000033;
  background-color: #fff;

  animation: ${pageIn} 1s ease;
`;
exports.FooterWrapper = styled_components_1.default.footer `
  position: absolute;
  margin: 10px;
  right: 0px;
  bottom: 0px;
  color: #5f5f5f;

  @media (max-width: 640px) {
    display: none;
  }
`;
